import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../areas/user/auth/providers/auth.service';

@Injectable({
    providedIn: 'root'
})

export class IdleDetectionService {

    private idleDetectionInterval: Subscription;

    constructor(private authService: AuthService) {}

    watchIdle() {
        this.clearIdleDetectionInterval();

        if (this.authService.isAuthTokenValid()) {
            this.idleDetectionInterval = interval(1000).subscribe(() => {
                const lastActivityTimestamp = this.getLastActivityTimestamp();

                if (!lastActivityTimestamp) {
                    this.setLastActivityTimestamp();
                }

                if (lastActivityTimestamp && moment().unix() - Number(lastActivityTimestamp) > (environment.idleTimeoutInMinutes * 60)) {
                    this.clearIdleDetectionInterval();
                    this.authService.logoutUserDueToInactivity();
                }
            });
        } else {
            this.clearIdleDetectionInterval();
            this.clearLastActivityTimestamp();
        }
    }

    getLastActivityTimestamp() {
        return localStorage?.getItem('last-activity-timestamp');
    }

    setLastActivityTimestamp() {
        localStorage.setItem('last-activity-timestamp', moment().unix().toString());
    }

    clearLastActivityTimestamp() {
        localStorage.removeItem('last-activity-timestamp');
    }

    clearIdleDetectionInterval() {
        if (this.idleDetectionInterval) {
            this.idleDetectionInterval?.unsubscribe();
        }
    }
}
